var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail_ad_container"},[_c('div',{staticClass:"detail_ad_image_container",on:{"click":_vm.navigateByAdSettings}},[_c('img',{staticClass:"detail_ad_image",attrs:{"src":_vm.performanceInfo.projectServing.pictureURL}})])])}
var staticRenderFns = []

export { render, staticRenderFns }